import PropTypes from 'prop-types';

import './SettingDetails.scss';

// One line's worth of spans. A span is either marked or it isn't, so this is a lookup rather than
// a nesting problem — see parseInline.
const renderSpans = (spans) =>
  spans.map((span, index) => {
    if (span.bold) return <strong key={index}>{span.text}</strong>;
    if (span.italic) return <em key={index}>{span.text}</em>;
    return span.text;
  });

/**
 * The long-form page behind a settings row, rendered from the blocks parseMarkdown returns.
 *
 * Elements are built directly rather than from an HTML string, so no content ever reaches
 * dangerouslySetInnerHTML and there is nothing to escape on the way in.
 */
const SettingDetails = ({ blocks }) => {
  if (!Array.isArray(blocks)) return null;

  return (
    <div className="SettingDetails">
      {blocks.map((block, index) => {
        if (block.type === 'heading') {
          return (
            <h4 key={index} className="heading">
              {renderSpans(block.spans)}
            </h4>
          );
        }

        if (block.type === 'list') {
          return (
            <ul key={index} className="list">
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>{renderSpans(item)}</li>
              ))}
            </ul>
          );
        }

        return (
          <p key={index} className="paragraph">
            {renderSpans(block.spans)}
          </p>
        );
      })}
    </div>
  );
};

const spansPropType = PropTypes.arrayOf(
  PropTypes.shape({
    text: PropTypes.string.isRequired,
    bold: PropTypes.bool,
    italic: PropTypes.bool,
  })
);

export const blocksPropType = PropTypes.arrayOf(
  PropTypes.shape({
    type: PropTypes.oneOf(['heading', 'paragraph', 'list']).isRequired,
    level: PropTypes.number,
    spans: spansPropType,
    items: PropTypes.arrayOf(spansPropType),
  })
);

SettingDetails.propTypes = {
  blocks: blocksPropType,
};

export default SettingDetails;
